<template>
    <nav class="navigation">
        <button :class="['navItem', 'bounding', 'resetButton', { 'router-link-exact-active' : isCurrentRouteHome }]"
            @click="handleHome">
            <Icon icon="home"/>
        </button>

        <button class="navItem bounding resetButton"
            v-if="auth.id"
            @click="$emit('openSearchModal')">
            <Icon icon="search"/>
        </button>

        <div class="newEntry bounding">
            <button :class="['navItem', 'resetButton', { active : uploadDropdown }]"
                @click="handleOpen">
                <Icon class="uploadIcon"
                    appearance="inherit"
                    icon="add_circle"/>
            </button>

            <transition name="slideUp">
                <Dropdown class="uploadDropdown"
                    v-if="uploadDropdown"
                    v-on-clickaway="closeDropdown"
                    :elements="uploadOptions"
                    @uploadCarousel="$emit('openNewEntryModal', 'carousel')"
                    @uploadSlider="$emit('openNewEntryModal', 'slider')">
                    <template slot="0">
                        <div class="mediaIcon carouselIcon"></div>
                        New carousel
                    </template>
                    <template slot="1">
                        <div class="mediaIcon sliderIcon"></div>
                        New slider
                        <div class="newFeature">
                            <Icon class="newIcon"
                                appearance="inherit"
                                size="xs"
                                icon="temp_preferences_custom"/>
                            New
                        </div>
                    </template>
                </Dropdown>
            </transition>
        </div>

        <router-link class="navItem bounding"
            to="/blog">
            <Icon icon="public"/>
        </router-link>

        <router-link class="navItem bounding"
            v-if="auth.id"
            :to="'/creator/' + loggedInUser.slug">
            <img class="avatar"
                :alt="'avatar of ' + loggedInUser.name"
                :src="avatar"/>
        </router-link>
    </nav>
</template>

<script>
    import { mixin as clickaway } from 'vue-clickaway'

    export default {
        name: 'Navigation',
        mixins: [ clickaway ],
        data() {
            return {
                newEntryModal: false,
                uploadDropdown: false,
                uploadOptions: [
                    {
                        action: 'uploadCarousel'
                    },
                    {
                        action: 'uploadSlider'
                    }
                ]
            }
        },
        computed: {
            avatar() {
                if(this.loggedInUser.avatar) {
                    return this.loggedInUser.avatar
                } else {
                    return this.constants.defaults.avatar
                }
            },
            isCurrentRouteHome() {
                return this.$route.name === 'home'
            }
        },
        methods: {
            handleHome() {
                if(!this.isCurrentRouteHome) {
                    this.$router.push('/')
                } else {
                    document.getElementById('app').scrollIntoView({ behavior: 'smooth' })
                }
            },
            closeDropdown() {
                this.uploadDropdown = false
            },
            handleOpen() {
                if(this.auth.id) {
                    this.uploadDropdown = true
                } else {
                    this.$router.push('/auth')
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../../scss/variables';

    .navigation {
        position: absolute;
        top: 0.25rem;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        align-items: center;
        width: 100%;
        height: calc(100% - 0.5rem);
        max-width: 40rem;
    }

    .navItem {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        flex: 1;
        height: 100%;
        user-select: none;
        cursor: pointer;
    }

    .bounding {
        display: flex;
        flex: 1;
        height: 100%;
        padding: 0.25rem;
        margin: 0 0.25rem;
        border-radius: 0.75rem;

        &:hover, &:focus {
            background: var(--color-white-40);
        }

        &:focus {
            box-shadow: none;
            outline: 0;
        }
    }

    .dark {
        transition: $transition-eio-20;
    }

    .router-link-exact-active {
        .dark {
            color: var(--color-primary-500);
            transform: scale(1.2);

            &:hover {
                color: var(--color-primary-500);
            }
        }

        .avatar {
            transform: scale(1.2);
        }
    }

    .avatar {
        width: 1.75rem;
        height: 1.75rem;
        object-fit: cover;
        border-radius: 0.75rem;
        transition: $transition-eio-20;
    }

    .resetButton {
        appearance: none;
        outline: none;
        border: none;
        background: transparent;
        color: var(--color-black);
    }

    .active {
        color: var(--color-primary-500);
    }

    .newEntry {
        position: relative;
    }

    .uploadDropdown {
        position: absolute;
        left: 50%;
        top: 3.5rem;
        transform: translateX(-50%);
    }

    .mediaIcon {
        width: 1.5rem;
        height: 1.5rem;
        display: block;
        margin-right: 0.5rem;
    }

    .carouselIcon {
        content: var(--carousel);
    }

    .sliderIcon {
        content: var(--slider);
    }

    .newFeature {
        display: flex;
        align-items: center;
        padding: 0.15rem 0.5rem;
        border-radius: 0.5rem;
        background: var(--gradient-brand-500);
        margin-left: 0.75rem;
    }

    .newIcon {
        margin-right: 0.5rem;
    }

    @media all and (max-width: 1200px) {
        .navigation {
            position: relative;
            top: auto;
            left: auto;
            transform: translateX(0);
            justify-content: space-between;
            height: 100%;
        }

        .uploadDropdown {
            bottom: 3.75rem;
            top: auto;
        }
    }

    @media all and (max-width: 1024px) {
        .navItem {
            &:hover {
                background: none;
            }
        }
    }
</style>